export const getTypeQueries = function (this: { childs?: any[] }) {
    const selecteds: any[] =
        this?.childs?.filter((child: any) => child.selected) || [];

    const res = selecteds.map((child: any) => child.id);
    return selecteds.length
        ? {
            [selecteds[0].query]: selecteds[0]?.isSingle
                ? res[0]
                : JSON.stringify(res),
        }
        : {};
};

export const getCityQueries = function (this: { childs?: any[] }, incomingQueries: any) {
    let selecteds: any[];

    if (incomingQueries?.city) {
        selecteds =
            this?.childs?.filter((child: any) => {
                return child.id == JSON.parse(incomingQueries.city)
            }) || [];
        this.childs = this?.childs?.map((child: any) => {
            return {
                ...child,
                selected: child.id == JSON.parse(incomingQueries.city)
            }
        });

    } else {
        selecteds =
            this?.childs?.filter((child: any) => child.selected) || [];
    }
    const res = selecteds.map((child: any) => child.id);
    return res;
};

export const getPriceQueries = function (this: any) {
    const res: any[] = this?.childs
        ?.filter((child: any) => child.id)
        .reduce(
            (acc: any, child: any) => ({
                ...acc,
                [child.query]: child.id,
            }),
            {},
        );
    return res;
};

export const getFilterChildQueries = function (this: { childs?: any[] }) {
    const res: any[] = this?.childs?.reduce(
        (acc: any, child: any) => ({
            ...acc,
            ...child.getQueries(),
        }),
        {},
    );
    return res;
};

export const getFilterCountryQueries = function (this: { childs?: any[] }, incomingQueries: any = {}) {
    const res: any[] = this?.childs?.reduce((acc: any, child: any) => {
        const queries = child.getQueries(incomingQueries);
        return [...acc, ...queries];
    }, []);
    return res.length ? {city: JSON.stringify(res)} : {};
};

export const getChildQueries = function (this: any) {
    const res: any[] = this?.childs
        ?.filter((child: any) => child.selected && child.id)
        .map((child: any) => child.id);

    return res.length
        ? {
            [this?.query]: JSON.stringify(res),
        }
        : {};
};

export const getFloorAreaQueries = function (this: any) {
    const res = this.childs
        .filter((child: any) => child.selected)
        .reduce(
            (acc: any, next: any) => ({
                ...acc,
                ...next.query,
            }),
            {},
        );
    return res;
};

export const getFloorQueries = function (this: any) {
    const res = this.childs
        .filter((child: any) => child.value)
        .reduce(
            (acc: any, next: any) => ({
                ...acc,
                [next.key]: next.value,
            }),
            {},
        );
    return res;
};
